import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['pt-BR', 'en-US', 'es-ES'],
  defaultLocale: 'pt-BR',
  // Do not follow Accept-Language; system default is pt-BR unless URL/cookie chooses another locale.
  localeDetection: false,
});
